import {
  API_ENDPOINT,
  useClientApiV3AuthSignupCreateMutation,
} from '../../resources/@types/accountSchema';

interface UseClientV3AuthSignupMutation {
  options?: Parameters<typeof useClientApiV3AuthSignupCreateMutation>[0]['options'];
}

export function useAuthSignupCreateMutation({ options }: UseClientV3AuthSignupMutation) {
  return useClientApiV3AuthSignupCreateMutation({
    url: API_ENDPOINT.CLIENT_V3_AUTH_SIGNUP,
    options,
  });
}
